import React, { useState } from 'react'
import MenuItem from '@material-ui/core/MenuItem'
import Input from '@material-ui/core/Input'
import Select from '@material-ui/core/Select'
import { makeStyles } from '@material-ui/core/styles'
import Checkbox from '@material-ui/core/Checkbox'
import Typography from '@material-ui/core/Typography'
import UnfoldMoreIcon from '@material-ui/icons/UnfoldMore'
import { Loader } from 'components'
import InputWrapper from './InputWrapper'
import $ from 'jquery';

const useStyles = makeStyles(({ palette, spacing }) => ({
  chips: {
    display: `flex`,
    flexWrap: `wrap`,
  },
  chip: {
    margin: 2,
  },
  check: {
    fill: palette.success.main,
  },
  emptyText: {
    textAlign: `center`,
  },
  filterInput: {
    background: `white`,
    border: `none`,
    borderBottom: `3px solid #dcdde5`,
  },
  option: {
    minHeight: `auto !important`,
    padding: spacing(0.9, 2),
  },
  loaders: {
    padding: 0,
  },
  loaderIcon: {
    width: `25px !important`,
    height: `25px !important`,
  },
}))

const ITEM_HEIGHT = 48
const ITEM_PADDING_TOP = 8
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
}

export default function SelectWrapper({
  id,
  label,
  error = false,
  isRequired = false,
  disabled = false,
  onChange,
  classes: classesParent,
  items = [],
  value = -1,
  id: name,
  mode = `default`,
  placeholder = `Seleccione`,
  align = `left`,
  md = 12,
  xs = 12,
  variant = `standard`,
  withSelectOption = true,
  isValid,
  loading = false,
  rules = {},
  selected,
  ...rest
}) {
  const classes = useStyles()
  const iconName = isValid && value !== -1 && value !== null ? `check` : `select`

  const [focusin, setfocusin] = useState(false);

  let props = {
    name,
    classes: classesParent,
    variant,
    mode, //MULTI DEFAULT ETC...,
    placeholder,
    value,
    error: !!error,
    disabled,
    inputProps: {
      classes: {
        icon: iconName === `check` ? classes.check : ``,
      },
      className: hasValidValue() && `validInput`,
    },
    MenuProps: { autoFocus: false,disableAutoFocus:true,disableEnforceFocus:true  },
  }

  if (mode === `multiple`) {
    props = {
      ...props,
      multiple: true,
      input: <Input id="select-multiple-chip" />,
      MenuProps,
      value: Array.isArray(value) && value.length > 0 ? value : [-1],
      renderValue,
    }
  }

  const isChecked = itemValue => {
    const item = props.value.find(x => x === itemValue)
    return item !== undefined
  }

  function handleOnChange({ value: selectedValue, meta }) {
    
    //console.log("meta",meta)
    //console.log("selectedValue",selectedValue)
    if (mode === `multiple`) {
      
      let nextValue = []
      if (value.includes(selectedValue)) {
        // select the same and delete it
        nextValue = value.filter(oldVal => oldVal !== selectedValue)
        //console.log("pasa por el 1")
      } else {
        // select new one and add it
        nextValue = [...value, selectedValue]
        //console.log("pasa por el 2")
      }
      return onChange({ selected: selectedValue, value: nextValue, name, meta })
    }
    
    
    return onChange({
      selected: selectedValue,
      value: value === selectedValue ? -1 : selectedValue,
      name,
      meta,
    })

  }

  function renderValue(value) {
    let selectedValues =
      mode === `multiple`
        ? value.includes(-1)
          ? placeholder
          : ``
        : value === -1
        ? placeholder
        : ``
    let count = 1
    items.forEach(({ value: itemValue, label: itemLabel }) => {
      if (mode === `multiple`) {
        if (value.includes(itemValue)) {
          selectedValues += count > 1 ? `, ${itemLabel}` : `${itemLabel}`
          count += 1
        }
      } else if (value === itemValue) {
        selectedValues = itemLabel
      }
    })
    return (
      <Typography
        variant="body1"
        noWrap
        style={{
          maxWidth: `93%`,
        }}
      >
        {selectedValues}
      </Typography>
    )
  }

  function hasValidValue() {
    if (mode === `multiple`) {
      return value.length > 0
    }
    return value !== -1 && value !== null && value !== undefined
  }


  const miEstilo={
        width:'100%',
        borderRadius:'5px',
        border:'1px solid #7F8FA4',
        minHeight:'40px',
        
  }

  //console.log('el valor del select debería ser: ',value);
  //console.log('el valor del selected debería ser: ',rest);

  return (
    <InputWrapper
      label={label}
      error={error}
      isRequired={isRequired || rules.required}
      align={align}
      md={md}
      xs={xs}
      disabled={disabled}
      {...rest}
      type="select"
    >
      {loading ? (
        <Loader classes={{ root: classes.loader, icon: classes.loaderIcon }} />
      ) : (
        /*
        <Select
          IconComponent={UnfoldMoreIcon}
          
          className={variant === `filled` ? classes.filterInput : ``}
          {...props}
        >
          {withSelectOption && (
            <MenuItem value={-1} disabled className={classes.option}>
              {placeholder}
            </MenuItem>
          )}
          {items.map(({ value: itemValue, label: itemLabel }, i) => (
            <MenuItem
              key={`${i}-${itemLabel}`}
              onClick={() => handleOnChange({ value: itemValue, meta: itemLabel })}
              value={itemValue}
              className={classes.option}
            >
              {mode === `multiple` && <Checkbox checked={isChecked(itemValue)} />}
              {itemLabel}
            </MenuItem>
          ))}
        </Select>*/
        
        <select 
          {...props}
          //multiple={mode==='multiple'} 
          style={miEstilo}
          id={id}
          
          onChange={(e) => handleOnChange({ value: e.target.value, meta: e.target.options[e.target.selectedIndex].text })}
          
          className={variant === `filled` ? classes.filterInput : ` seleccionable`}>
            
          {withSelectOption && (
            <option value={-1} className={classes.option}>
              {placeholder}
            </option>
          )}
          {items.map(({ value: itemValue, label: itemLabel }, i) => {
           
            return (
              <option
                key={`${i}-${itemLabel}`}
                onClick={(e) => handleOnChange({ value: itemValue, meta: itemLabel })}
                value={itemValue}
                className={classes.option}
              >
                {itemLabel}
              </option>
            );
          }
          )}
        </select>
      )}
    </InputWrapper>
  )
}
